<template>
    <b-modal
        ref="show-modal"
        :title="$t('tournament.show_modal.title')"
        cancel-title="Close"
        ok-only
        size="lg"
    >
      <h4>{{ $t('tournament.show_modal.section_basic_data_title') }}</h4>
      <div class="row">
        <div class="col-12">
          <table class="table">
            <tr>
              <th>{{ $t('tournament.show_modal.id') }}</th>
              <td>{{ data.id }}</td>
            </tr>
            <tr>
              <th>{{ $t('tournament.show_modal.tournament_id') }}</th>
              <td>{{ data.tournamentId }}</td>
            </tr>
            <tr>
              <th>{{ $t('tournament.show_modal.name') }}</th>
              <td>{{ data.name }}</td>
            </tr>
            <tr>
              <th>{{ $t('tournament.show_modal.question_category') }}</th>
              <td>{{ $t(`category.${data.questionCategoryLabel}`) }}</td>
            </tr>
            <tr>
              <th>{{ $t('tournament.show_modal.wallet_currency') }}</th>
              <td>{{ data.walletCurrency }}</td>
            </tr>
            <tr>
              <th>{{ $t('tournament.show_modal.buy_in') }}</th>
              <td>{{ data.buyIn }}</td>
            </tr>
            <tr>
              <th>{{ $t('tournament.show_modal.prize_pool') }}</th>
              <td>
                <ul style="list-style: none; padding-left: 0;">
                  <li v-for="(item, key, index) in data.prizePool" :key="index">{{ $t('tournament.show_modal.prize_pool.position') }}: {{ item.position }}, {{ $t('tournament.show_modal.prize_pool.award') }}: {{ item.award }}</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>{{ $t('tournament.show_modal.prize_pool_sum') }}</th>
              <td>{{ data.prizePoolSum }}</td>
            </tr>
            <tr>
              <th>{{ $t('tournament.show_modal.award_winning_positions') }}</th>
              <td>{{ data.awardWinningPositions }}</td>
            </tr>
            <tr>
              <th>{{ $t('tournament.show_modal.player_numbers') }}</th>
              <td>{{ data.requiredNumberOfPlayers }}</td>
            </tr>
            <tr>
              <th>{{ $t('tournament.show_modal.max_players') }}</th>
              <td>{{ data.gameParameters.maxPlayers }}</td>
            </tr>
            <tr>
              <th>{{ $t('tournament.show_modal.winner_game_player_quantity') }}</th>
              <td>{{ data.tournamentParameters.winnerGamePlayerQuantity }}</td>
            </tr>
            <tr>
              <th>{{ $t('tournament.show_modal.quiz_ranking_points') }}</th>
              <td>
                <ul style="list-style: none; padding-left: 0;">
                  <li v-for="(item, key, index) in data.quizRankingPoints" :key="index">{{ item.position }}: {{ item.points }}</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>{{ $t('tournament.show_modal.password') }}</th>
              <td>{{ data.password }}</td>
            </tr>
            <tr>
              <th>{{ $t('tournament.show_modal.created_at') }}</th>
              <td>{{ data.createdAt | dateTimeFormat }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h4>{{ $t('tournament.show_modal.section_stages_title') }}</h4>
          <table class="table">
            <tr>
              <th>{{ $t('tournament.show_modal.round_type') }}</th>
              <th>{{ $t('tournament.show_modal.cms_key_name') }}</th>
              <th>{{ $t('tournament.show_modal.number_of_rounds') }}</th>
              <th>{{ $t('tournament.show_modal.round_configuration') }}</th>
            </tr>
            <tr v-for="(stage, index) in data.gameParameters.stagesParameters" :key="index">
              <td>{{ stage.roundType }}</td>
              <td>{{ stage.cmsPageKeyName }}</td>
              <td>{{ stage.numberOfRounds }}</td>
              <td>
                <ul>
                  <li v-for="(value,key) in stage.roundConfiguration" :key="key">{{ key }}:{{ value }}</li>
                </ul>
              </td>
            </tr>
          </table>
          <h4>{{ $t('tournament.show_modal.section_final_stages_title') }}</h4>
          <table class="table">
            <tr>
              <th>{{ $t('tournament.show_modal.min_time') }}</th>
              <th>{{ $t('tournament.show_modal.points_multiplier') }}</th>
              <th>{{ $t('tournament.show_modal.cms_key_name') }}</th>
              <th>{{ $t('tournament.show_modal.rounds_no_to_change_time') }}</th>
              <th>Time Bonus</th>
              <th>Time Penalty</th>
            </tr>
            <tr>
              <td>{{data.gameParameters.finalStageParameters.minAmountOfTime}}s</td>
              <td>{{data.gameParameters.finalStageParameters.pointsMultiplier}}</td>
              <td>{{data.gameParameters.finalStageParameters.cmsPageKeyName}}</td>
              <td>{{data.gameParameters.finalStageParameters.numberOfRoundsToChangeTime}}</td>
              <td>{{data.gameParameters.finalStageParameters.roundConfiguration.questionTimeBonus}}s</td>
              <td>{{data.gameParameters.finalStageParameters.roundConfiguration.questionTimePenalty}}s</td>
            </tr>
          </table>
        </div>
      </div>
    </b-modal>
</template>


<script>

//TODO: import / load / get locale the right way
let locale = locale ? locale : "en";

export default {
  data() {
    return {
      data: {
        awardWinningPositions: null,
        prizePoolSum: null,
        id: null,
        tournamentId: null,
        name: null,
        createdAt: null,
        tournamentParameters: [],
        questionCategoryLabel: null,
        walletCurrency: null,
        buyIn: null,
        prizePool: null,
        gameParameters: {
          buyIn: null,
          quizRankingPoints: null,
          prizePool: null,
          maxPlayers: null,
          walletCurrency: null,
          stagesParameters: [],
          finalStageParameters: {
            pointsMultiplier: null,
            minAmountOfTime: null,
            numberOfRoundsToChangeTime: null,
            roundConfiguration: {
              questionTimeBonus: null,
              questionTimePenalty: null,
            },
            cmsPageKeyName: null
          },
        },
      }
    };
  },
  filters: {},
  mounted() {
    this.showModal();
  },
  methods: {
    setData(data) {
      this.data = data;
    },
    showModal(){
      this.$refs['show-modal'].show();
    }
  }
}
</script>
